import { render, staticRenderFns } from "./BFSLogo.vue?vue&type=template&id=282fe4e5&"
import script from "./BFSLogo.vue?vue&type=script&lang=js&"
export * from "./BFSLogo.vue?vue&type=script&lang=js&"
import style0 from "./BFSLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports